import React, {useState} from 'react'
import { useHistory } from "react-router-dom"
import "./growth.css"
import Header from "./Header"
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ReferenceLine,
} from 'recharts';



function PlotG() {

     
    let history = useHistory();



    //Day of Life (dol) => X AXIS

     var dol1 = localStorage.getItem("Day of life 1")
     var x1 = parseInt(dol1)
     var dol2 = localStorage.getItem("Day of life 2")
     var x2 = parseInt(dol2)
     var dol3 = localStorage.getItem("Day of life 3")
     var x3 = parseInt(dol3)
     var dol4 = localStorage.getItem("Day of life 4")
     
     var x4 = parseInt(dol4)
     
     var dol5 = localStorage.getItem("Day of life 5")
     var x5 = parseInt(dol5)
     var dol6 = localStorage.getItem("Day of life 6")
     var x6 = parseInt(dol6)
     var dol7 = localStorage.getItem("Day of life 7")
     var x7 = parseInt(dol7)
     var dol8 = localStorage.getItem("Day of life 8")
     var x8 = parseInt(dol8)
     console.log("x8", x8)

     

     var x22 = "day" + " " + x2 + " " + "of life"
     console.log(x22)


     var weightt1 = localStorage.getItem("weight 1")
     var weightt2 = localStorage.getItem("weight 2")
     var weightt3  = localStorage.getItem("weight 3")
     var weightt4  = localStorage.getItem("weight 4")
     var weightt5  = localStorage.getItem("weight 5")
     var weightt6  = localStorage.getItem("weight 6")
     var weightt7  = localStorage.getItem("weight 7")
     var weightt8  = localStorage.getItem("weight 8")


     var gdol11 = (Math.log(weightt1 / 0) * 1000) / (dol1)
     var gdol1 = gdol11.toFixed(2)
     localStorage.setItem("gdol1", gdol1);
     var y1= parseFloat(gdol1)
     console.log(y1)
     var gdol22 = (Math.log(weightt2 / weightt1) * 1000) / (dol2 - dol1)
     var gdol2 = gdol22.toFixed(2)
     localStorage.setItem("gdol2", gdol2);
     var y2= parseFloat(gdol2)
     console.log(y2)
     var gdol33 = (Math.log(weightt3 / weightt2) * 1000) / (dol3 - dol2)
     var gdol3 = gdol33.toFixed(2)
     localStorage.setItem("gdol3", gdol3);
     var y3= parseFloat(gdol3)
     console.log(y3)
     var gdol44 = (Math.log(weightt4 / weightt3) * 1000) / (dol4 - dol3)
     var gdol4 = gdol44.toFixed(2)
     localStorage.setItem("gdol4", gdol4);
     var y4= parseFloat(gdol4)
     console.log(y4)
     var gdol55 = (Math.log(weightt5 / weightt4) * 1000) / (dol5 - dol4)
     var gdol5 = gdol55.toFixed(2)
     localStorage.setItem("gdol5", gdol5);
     var y5= parseFloat(gdol5)
     console.log(y5)
     var gdol66 = (Math.log(weightt6 / weightt5) * 1000) / (dol6 - dol5)
     var gdol6 = gdol66.toFixed(2)
     localStorage.setItem("gdol6", gdol6);
     var y6= parseFloat(gdol6)
     console.log(y6)
     var gdol77 = (Math.log(weightt7 / weightt6) * 1000) / (dol7 - dol6)
     var gdol7 = gdol77.toFixed(2)
     localStorage.setItem("gdol7", gdol7);
     var y7= parseFloat(gdol7)
     console.log(y7)
     var gdol88 = (Math.log(weightt8 / weightt7) * 1000) / (dol8 - dol7)
     var gdol8 = gdol88.toFixed(2)
     localStorage.setItem("gdol8", gdol8);
     var y8= parseFloat(gdol8)
     console.log(y8)
     var y9 = 0; // no growth @ x8 ?

    
    const data01 = [
 
    {x: x2, y:y2 == ("Infinity" || "undefined") ? 0.0 : y2 }, { x: x3, y:y3 }, {x:(x4 == "null" ? 0 : x4), y:(y4 == ("Infinity" || "undefined") ? 0.0 : y4)},
    {x:(x5 == "null" ? 0 : x5), y:y5 == ("Infinity" || "undefined") ? 0.0 : y5}, {x:(x6 == "null" ? 0 : x6), y:(y6 == ("Infinity"||"undefined") ? 0.0 : y6)},
    {x:(x7 == "null" ? 0 : x7), y:(y7 == ("Infinity"||"undefined") ? 0.0 : y7)}, {x:(x8 == "null" ? 0 : x8), y:(y8 == ("Infinity"||"undefined") ? 0.0 : y8)} ]


    const scores = (e) => {
      e.preventDefault()
        history.push("/z-score"); 
        //window.location.replace("/z-score")
        
    }

    return (
        <div className="row">
        <div className="col-md-12">
        <div className="growth__page3">
        <Header/>
        <div className="plot__content">
          
          <div className ="plot__header">
            <strong>Weight Velocity</strong>
          </div>
          <div className ="bug__at__graph">
          **Tap the dot to see the exact value of each time point(s).
        </div>
        
        <div className ="bug__at__graph1">
          Ideal Weight Velocity: 15 g/kg/day
        </div>

<LineChart
        width={350}
        height={350}
        data = {data01} 
       className = "graph__responsive"
       
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis stroke={false} tickLine= {false} interval = {0}  label={{ value: "Day of Life", position: "Center",  dy: 10}}
        ticks={[0,10,20,30,40,50,60,70,80,90]}  domain={["auto"]} type="number" dataKey="x" allowDataOverflow   />
        <ReferenceLine  y={0} stroke = "#000000"/>
        <YAxis label={{ value: "Growth Velocity (g/kg/day)", position: "Left", angle: -90, dx: -5,   dy: 10}}
        domain={['auto']} responsive type = "number" dataKey="y" name = "growth velocity" allowDataOverflow stroke = "#000000"/>
        <Tooltip responsive cursor={{ strokeDasharray: '4 4' }} />
        <Line allowDataOverflow type="monotone" name = "growth velocity" dataKey="y" unit = " g/kg/day" stroke="blue" activeDot={{ r: 10 }} />

      </LineChart>


            <div> 
            <button className = "goto__zscore" onClick = {scores}>Z-Scores</button>
            </div>
            </div>
        </div>
        </div>
        </div>
    )
}

export default PlotG;
